import { getItem, removeItem, setItem } from '@/lib';

const TUTORIAL = 'tutorial';

export type TutorialType = {
  finished: boolean;
  hasFinishedOnce: boolean;
  index: number;
};

export const getTutorial = () => getItem<TutorialType>(TUTORIAL);
export const removeTutorial = () => removeItem(TUTORIAL);
export const setTutorial = (value: TutorialType) =>
  setItem<TutorialType>(TUTORIAL, value);
